import { fetch, Method, getPaging } from 'core/api/fetch';
import { parseExperiencerToModel, parseExperiencerToObject, parseApiKeyToModel } from 'core/api/parser/experiencer';

const ExperiencerRoutes = {
  getList: (options) => `/api/v1.1.0/admin/experiencer?multiSearch=${options.multiSearch}&${getPaging(options)}`,
  get: (id) => `/api/v1.1.0/admin/experiencer/${id}`,
  update: (id) => `/api/v1.1.0/admin/experiencer/${id}`,
//   updateAvatar: (experiencer) => `/api/v1.1.0/experiencer/${experiencer}/image`,

  // Commissions
  getCommissions: (experiencerId) => `/api/v1.1.1/admin/experiencer/${experiencerId}/commission`,
  patchCommission: (experiencerId, commissionId) => `/api/v1.1.1/admin/experiencer/${experiencerId}/commission/${commissionId}`,
  deleteCommission: (experiencerId, commissionId) => `/api/v1.1.1/admin/experiencer/${experiencerId}/commission/${commissionId}`,
  addCommission: (experiencerId) => `/api/v1.1.1/admin/experiencer/${experiencerId}/commission`,

  // API Keys
  getApiKeys: (experiencerId) => `/api/v1.1.1/admin/experiencer/${experiencerId}/apikey`,
  postApiKey: (experiencerId) => `/api/v1.1.1/admin/experiencer/${experiencerId}/apikey`,
  deleteApiKey: (experiencerId, keyId) => `/api/v1.1.1/admin/experiencer/${experiencerId}/apikey/${keyId}`,
};

export const ExperiencerService = {

  getExperiencers: async (options) => {
    try {
      const { data } = await fetch(ExperiencerRoutes.getList(options), {
        method: Method.GET,
        authenticated: true
      });
    //   return !data || !data.length ? [] : data.map(parseExperiencerToModel);
      return !data ? {experiencers:[],total:0} : {total: data.total, experiencers: data.experiencers.map(parseExperiencerToModel)};
    } catch (err) {
      throw new Error(err);
    }
  },

  get: async (options) => {
    try {
      const { data } = await fetch(ExperiencerRoutes.get(options), {
        method: Method.GET,
        authenticated: true
      });
    //   return !data || !data.length ? [] : data.map(parseExperiencerToModel);
      return !data || !data.length ? {} : parseExperiencerToObject(data[0]);
    } catch (err) {
      throw new Error(err);
    }
  },

  update: async (info) => {
    try {
      const { data } = await fetch(ExperiencerRoutes.update(info.id), {
        method: Method.PATCH,
        authenticated: true,
        data: info,
      });
      return Array.isArray(data) ? data[0] : false;
    } catch (err) {
      throw new Error(err);
    }
  },

//   updateAvatar: async (id, image) => {
//     try {
//       const formData = new FormData();
//       image =
//         image.type && image.type !== ''
//           ? image
//           : image.slice(0, image.size, 'image/png');
//       formData.append('images', image, image.name ?? 'avatar.png');
//       await fetch(ExperiencerRoutes.updateAvatar(id), {
//         method: Method.POST,
//         authenticated: true,
//         data: formData,
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//     } catch (err) {
//       throw new Error(err);
//     }
//   },

  // Commissions
  getCommissions: async (experiencerId) => {
      try {
          const { data } = await fetch(ExperiencerRoutes.getCommissions(experiencerId), {
              method: Method.GET,
              authenticated: true,
          });

          return data.experiencerCommissions ?? false;
      } catch (error) {
          throw new Error(error);
      }
  },
  patchCommission: async (experiencerId, commissionId, body) => {
      try {
          const { data } = await fetch(ExperiencerRoutes.patchCommission(experiencerId, commissionId), {
              method: Method.PATCH,
              authenticated: true,
              data: body,
          });

          return data;
      } catch (error) {
          throw new Error(error);
      }
  },
  deleteCommission: async (experiencerId, commissionId) => {
      try {
          const { data } = await fetch(ExperiencerRoutes.deleteCommission(experiencerId, commissionId), {
              method: Method.DELETE,
              authenticated: true,
          });

          return data;
      } catch (error) {
          throw new Error(error);
      }
  },
  addCommission: async (experiencerId, body) => {
      try {
          const { data } = await fetch(ExperiencerRoutes.addCommission(experiencerId), {
              method: Method.POST,
              authenticated: true,
              data: body,
          });

          return data;
      } catch (error) {
          throw new Error(error);
      }
  },

  // API Keys
  getApiKeys: async (experiencerId) => {
      try {
          const { data } = await fetch(ExperiencerRoutes.getApiKeys(experiencerId), {
              method: Method.GET,
              authenticated: true,
          });

          // Try different possible response structures
          const apiKeysData = data?.apiKeys || data?.experiencerApiKeys || data || [];
          
          // Parse each API key if data exists
          return Array.isArray(apiKeysData) ? apiKeysData.map(parseApiKeyToModel) : [];
      } catch (error) {
          throw new Error(error);
      }
  },
  postApiKey: async (experiencerId, body) => {
      try {
          const { data } = await fetch(ExperiencerRoutes.postApiKey(experiencerId), {
              method: Method.POST,
              authenticated: true,
              data: body,
          });

          return data;
      } catch (error) {
          throw new Error(error);
      }
  },
  deleteApiKey: async (experiencerId, keyId) => {
      try {
          const { data } = await fetch(ExperiencerRoutes.deleteApiKey(experiencerId, keyId), {
              method: Method.DELETE,
              authenticated: true,
          });

          return data;
      } catch (error) {
          throw new Error(error);
      }
  }
};
